import TimesTableOneToSixView from '../../maks2/views/times-table-1-6'

const TimesTableMenuView = TimesTableOneToSixView.extend({
    tables: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
})

export default TimesTableMenuView